module.exports = __webpack_public_path__ + "static/media/bill_add.ace86edc.ico";